export const meta = {
  title: 'Terms of Service | CADCraft AI',
  description:
    'Terms for using cadcraft.org and its hosted copy of the CADCraft web app.',
  updated_at: '2026-10-20',
};

## About the site

cadcraft.org ("the site") is operated by CADCraft AI. It is an **independent community guide** to CADCraft, offering download and installation guides, a feature comparison with Autodesk AutoCAD, tutorials and a hosted copy of the CADCraft web app. CADCraft is an open-source CAD application developed by the ArtCraft team ([github.com/storytold/cadcraft](https://github.com/storytold/cadcraft)). The site is not affiliated with Autodesk, Inc. or the ArtCraft team. AutoCAD is a registered trademark of Autodesk, Inc.

## The CADCraft software

CADCraft is licensed by its authors under MIT OR Apache-2.0. Whether you download the software from GitHub or run it in our hosted web version, your use of it is governed by those licenses. The software is provided **"as is", without warranty of any kind**. CADCraft is in early development; keep backups of your drawings and check results before relying on them.

## Hosted web version

We host an unmodified copy of the official CADCraft web build for convenience. We may update, change or stop hosting it at any time. On the free plan your drawings stay in your browser; with CADCraft Online Pro they are also saved to your account. Either way, you are responsible for keeping copies of important work.

## CADCraft Online Pro

CADCraft Online Pro is an optional paid subscription for cloud features on this site (cloud drawings, version history and share links). It pays for the features and hosting we add, not for the open-source CADCraft software, which stays free.

- **Billing.** Pro is billed in advance, monthly or yearly, through our payment provider (PayPal), and renews automatically at the end of each period until you cancel.
- **Cancelling.** You can cancel at any time in [Settings → Billing](/settings/billing) or in your PayPal account. You keep Pro until the end of the period you already paid for; after that your account returns to the free plan. You can still open, download and delete the cloud drawings you saved; you just can't save new ones.
- **Refunds.** If Pro isn't right for you, email [support@cadcraft.org](mailto:support@cadcraft.org) within 7 days of your first payment for a full refund. Renewals are not refunded, but you can cancel before the next one.
- **Changes.** If we change the price, we will tell existing subscribers before it applies to their next renewal.

## Content on the site

Guides, tutorials and comparisons are provided for information only and may become out of date. Prices, features and file-format support of CADCraft and AutoCAD can change; check the official sources before making decisions.

## Acceptable use

Do not attack, overload or attempt to break the site, scrape it in a way that harms its operation, or use it for unlawful purposes.

## Limitation of liability

To the fullest extent permitted by law, CADCraft AI is not liable for any indirect or consequential loss, or for loss of data, arising from your use of the site or the software.

## Changes and contact

We may update these terms; the date above shows the latest version. Questions: [support@cadcraft.org](mailto:support@cadcraft.org).
